import {BudgetFileInfoDialogComponent} from '../budget-file-info-dialog/budget-file-info-dialog.component';
import {CommonService} from '../../../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatPaginator, MatTableDataSource} from '@angular/material';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {UploadBudgetDialogComponent} from '../upload-budget-dialog/upload-budget-dialog.component';
import {UsedBudgetService} from '../../../services/used-budget.service';

@Component({
  selector: 'app-budget-settings',
  templateUrl: './budget-settings.component.html'
})
export class BudgetSettingsComponent implements OnInit {
  @ViewChild('paginator', {static: false}) paginator: MatPaginator;

  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public isLoading: boolean;
  public tableHeight: number;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService,
              private usedBudgetService: UsedBudgetService) {
    this.dataSource = new MatTableDataSource<any>([]);
    this.displayedColumns = [
      'id',
      'original_name',
      'date_uploaded',
      'is_active_name',
      'actions'
    ];
    this.tableHeight = window.innerHeight - 320;
    this.isLoading = false;
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;
      await this.initDatabase();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.error.message);
    } finally {
      this.commonService.setPaginatorTexts(this.paginator);
      this.isLoading = false;
    }
  }


  async initDatabase() {
    this.dataSource = new MatTableDataSource<any>(await this.usedBudgetService.fetchUploadedBudgetFiles() as any[]);
    this.dataSource.paginator = this.paginator;
  }

  browseFiles() {
    const dialog = this.matDialog.open(UploadBudgetDialogComponent, {});
    dialog.afterClosed().subscribe(async response => {
      if (response) {
        await this.initDatabase();
      }
    });
  }

  async setActivity($event: any, record: any) {
    try {
      this.isLoading = true;
      await this.usedBudgetService.setFileActivityStatus(record.id, record.is_active === 1 ? 0 : 1);
      const data = this.dataSource.data;
      const currentRecord = data.find(r => r.id === record.id);
      currentRecord.is_active = record.is_active === 1 ? 0 : 1;
      currentRecord.is_active_name = record.is_active === 1 ? 'ΕΝΕΡΓΟ' : 'ΑΝΕΝΕΡΓΟ';
      this.dataSource.data = data;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.error.message);
    } finally {
      this.isLoading = false;
    }
  }


  showInfo(row: any) {
    this.matDialog.open(BudgetFileInfoDialogComponent, {
      data: {
        rowId: row.id
      }
    });
  }
}
